import { useContext } from 'react';

import {
  CanEditFormFieldsContext,
  CanEditFormFieldsContextProps,
} from './can-edit-form-fields.context';

export const useCanEditFormFieldsContext = (): CanEditFormFieldsContextProps => {
  const context = useContext(CanEditFormFieldsContext);
  return context;
};
